module.exports = __webpack_public_path__ + "img/sea_grapes.ebdddb6d.png";